export default function FinanceSummaryData(data) {
  this.cat = data && data.cat ? data.cat : '';

  this.cat = data.otherCat ? data.otherCat : this.cat;

  // Attribute name and value will only be set on subcategories
  this.attributeName = data && data.attributeName ? data.attributeName : '';
  this.attributeValue = data && data.attributeValue ? data.attributeValue : '';

  this.count = data && data.count ? data.count : 0;
  this.totalValue = data && data.totalValue ? data.totalValue : 0;
  this.averageValue = data && data.averageValue ? data.averageValue : 0;
  this.gain = data && data.gain ? data.gain : 0;
  this.totalPurchasePrice = data && data.totalPurchasePrice ? data.totalPurchasePrice : 0;
}



// WEBPACK FOOTER //
// ./src/models/FinanceSummaryData.js